import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { CommentTaskModalComponent } from '../modals/comment-task-modal/comment-task-modal.component';

angular
  .module('common')
  .directive(
    'coCommentTaskModal',
    downgradeComponent({ component: CommentTaskModalComponent })
  );
